import React from "react";
import { Timeline } from "../../common/Fiche";
import { Pill } from "../../common/DataList";
import colors from "../../../helpers/colors";
import TimelineEventBody from "./TimelineEvent";
import { buildSynchroFTItem } from "./TimelineEventSynchroFT";
import { buildSuspensionRemobilisationItem } from "./TimelineEventSuspensionRemobilisation";

// La couleur d'événement fournie par l'API porte une sémantique
// (succès / envoi / incident / mise à jour) : on la reflète sur la pastille
// de type, la couleur pleine restant portée par le point de la timeline.
const COLOR_TONES = {
  success: "ok",
  danger: "ko",
  warning: "warn",
  primary: "neutral",
  info: "info",
};

export const buildTimelineItem = (event, index) => {
  if (event.kind === "SYNCHRO_FT") return buildSynchroFTItem(event);
  if (event.kind === "SUSPENSION_REMOBILISATION") return buildSuspensionRemobilisationItem(event);

  return {
    id: event.id ?? `ev${index}`,
    date: event.date,
    icon: event.icon,
    color: colors[event.color],
    badges: (
      <>
        <Pill tone={COLOR_TONES[event.color] ?? "neutral"}>{event.type}</Pill>
        {event.subType && <Pill tone="muted">{event.subType}</Pill>}
      </>
    ),
    title: event.title,
    body: <TimelineEventBody event={event} />,
  };
};

const RecipientTimeline = ({ events }) => (
  <div className="timeline-card">
    <Timeline
      ariaLabel="Parcours de l'allocataire"
      items={events.map(buildTimelineItem)}
      emptyMessage="Aucun événement dans le parcours de cet allocataire."
    />
  </div>
);

export default RecipientTimeline;
